
export const videoData = [

  {
    title: "Pipe cleaner",
    path: `tQMUjoMI3V8`,

  },
  {
    title: "Peeka boo",
    path: `PN1fVr77js4`,

  },
  {
    title: "Feeding the chick",
    path: `a1N_DjsVmTM`,

  },
  {
    title: "Magnetic tab",
    path: `VQewR_eKbRk`,

  },
  {
    title: "Egg smashing",
    path: `6l4QHmJ_v9w`,

  },
  {
    title: "Peg activity",
    path: `MUd5-Fg0wyE`,

  },
  {
    title: "Color recognition",
    path: `GkEfAH9HvXo`,

  },
  {
    title: "Water play",
    path: `M-b29wOwB0U`,

  },
  {
    title: "Busy binder",
    path: `CAoT_-vXoco`,

  },
  {
    title: "Problem solving",
    path: `A4JS7-aQAOM`,

  },
  {
    title: "Pipe joints",
    path: `4GZVOTxAuzY`,

  },
  {
    title: "Identifying alphabets",
    path: `oG9BLo0rf4A`,

  },
  {
    title: "Story book",
    path: `7p1TcehtzoE`,

  },
  {
    title: "Hungery cat",
    path: `Q9qw5etPZfk`,

  },
  {
    title: "Sticky wall ball",
    path: `hPh0NDnTb8A`,
  },
];
